module.exports = __webpack_public_path__ + "media/images/projects/17-header-f5d8c16734f56e2a4e5731c3efda9aa3.jpg";